<template>
  <div class="page-container">
    <UiToastList/>
    <div class="full-height-container h-full sm:h-full md:h-screen">
      <div class="flex flex-wrap">
        <div
          class="w-full sm:w-1/1 md:w-1/2 h-64 sm:h-64 md:h-screen"
        >
          <img
            class="w-full h-64 sm:h-64 md:h-screen object-cover object-center"
            src="@/assets/img/demo1.jpg"
            alt="Toyota"
          />
        </div>
        <!-- ... -->
        <div
          class="w-full sm:w-1/1 md:w-1/2 authorize-container h-auto sm:h-auto md:h-screen"
        >
          <div
            class="flex flex-col justify-center sm:min-auto min-h-full"
          >
            <h1 class="mb-8">
              <router-link :to="{ name: 'index'}" class="main-logo">
                <img src="@/assets/img/logo.png" alt="Toyota" />
              </router-link>
            </h1>
            <p class="text-left mb-8 page-title">
              Đăng nhập vào tài khoản
            </p>
            <div
              class="w-full sm:w-full md:w-auto form-container"
            >
                <div class="mb-6 form-controls">
                  <label
                    class="block text-sm font-bold mb-2"
                    for="username"
                  >
                    Số CMND / Mã số thuế
                  </label>
                  <input
                    class="appearance-none border w-full py-4 px-4 mb-2 text-gray-700 focus:outline-none with-error"
                    id="username"
                    type="text"
                    placeholder="Số CMND / Mã số thuế"
                    v-model="username"
                  />
                </div>
                  <p
                    :class="[ submitted && $v.username.$error && !$v.username.required ? 'block' : 'hidden' ]"
                    class="text-red-400 text-error mb-4"
                  >
                    Vui lòng nhập Số CMND / Mã số thuế
                  </p>
                <div class="mb-6 form-controls">
                  <label
                    class="block text-sm font-bold mb-2"
                    for="password"
                  >
                    Mật khẩu
                  </label>
                  <div class="relative">
                    <input
                      class="appearance-none border w-full py-4 px-4 mb-2 text-gray-700 leading-tight focus:outline-none pr-10"
                      id="password"
                      :type="passwordInputType"
                      placeholder="Mật khẩu"
                      v-model="password"
                    />
                    <!-- Xử lý bật tắt hiển thị password tương ứng icon-eye hoặc icon-eye-off -->
                    <i
                      :class="[ passwordInputType === 'password' ? 'icon-eye-off' : 'icon-eye' ]"
                      class="vlicon"
                      @click="showPassword"
                    ></i>
                  </div>
                  <p
                    :class="[ submitted && $v.password.$error && !$v.password.required ? 'block' : 'hidden' ]"
                    class="text-red-400 text-error mb-4"
                  >
                    Vui lòng nhập mật khẩu
                  </p>
                  <p
                    :class="[ error !== '' ? 'block' : 'hidden' ]"
                    class="text-red-400 text-error mb-4"
                  >
                    {{error}}
                  </p>
                </div>
                <!--<div class="flex mt-4 mb-3">
                  <label class="flex items-center">
                    <input
                      type="checkbox"
                      class="form-checkbox"
                      v-model="remember"
                    />
                    <span class="ml-2"
                    >Duy trì trạng thái đăng
                                                nhập</span
                    >
                  </label>
                </div>-->
                <!-- Just demo -->
                <div class="g-recaptcha">
                 <vue-recaptcha
                   ref="recaptcha"
                   @verify="onCaptchaVerified"
                   :loadRecaptchaScript="true"
                   :sitekey="recaptcha_site_key">
                 </vue-recaptcha>
                  <p
                    :class="[ pleaseTickRecaptchaMessage !== '' ? 'block' : 'hidden' ]"
                    class="text-red-400 text-error mb-4"
                  >
                    {{pleaseTickRecaptchaMessage}}
                  </p>
                </div>
                <div>
                  <button
                    class="submit-button block mt-8 w-full mb-2 bg-red-500 hover:bg-red-400 text-white font-bold py-2 px-4 border-red-700 hover:border-red-500 rounded"
                    @click="makeLogin"
                    :disabled="isRequest"
                  >
                    <vue-element-loading :active="isRequest"/>
                    Đăng nhập
                  </button>
                  <div class="text-center underline">
                    <router-link :to="{ name: 'forgetPassword'}">Quên mật khẩu?</router-link>
                  </div>
                  <div class="mt-8">
                    <div class="text-center underline" @click="isShownTermsModal=true">
                      <a href="#">Điều khoản</a>
                    </div>
                    <div class="text-center underline" @click="isShownPrivacyModal=true">
                      <a href="#"
                      >Chính sách bảo mật</a
                      >
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <UiModal closeOnOverlay :show.sync="isShownTermsModal">
    <div class="modal-container modal-scroll bg-white w-11/12 md:max-w-md mx-auto shadow-lg z-50 overflow-y-auto">
      <div class="modal-content text-left">
      <!--Title-->
      <div class="modal-header bg-danger text-white">
        <h5 class="modal-title">
          Điều khoản & Điều kiện
          <div class="modal-close" @click="isShownTermsModal=false">
            <img
              src="@/assets/img/icon-close-white.svg"
              alt="Close"
            />
          </div>
        </h5>
      </div>
      <!--Body-->
      <perfect-scrollbar>
      <div class="modal-body">
          <p><strong>Công ty TNHH TMV Tài chính TFSVN Việt Nam</strong> (sau đây gọi là “TFSVN”) xin gửi lời chào trân trọng tới quý khách hàng ghé thăm trang thông tin điện tử (website) của Công ty tại địa chỉ toyotafinance.com.vn hoặc info.toyotafinancial.com.vn . Chúng tôi rất cảm ơn sự quan tâm của bạn đến sản phẩm và tìm hiểu về trang thông tin điện tử của chúng tôi.<br> Xin vui lòng dành thời gian để đọc và tìm hiểu những điều khoản về thỏa thuận pháp lý giữa bạn và TFSVN như dưới đây. Thông qua việc truy cập, duyệt nội dung, hoặc sử dụng trang thông tin điện tử này, bạn công nhận rằng bạn đã đọc, hiểu và nhất trí với việc tuân thủ các điều chỉnh của những điều khoản này. Nếu bạn không nhất trí với những điều khoản này, xin vui lòng không sử dụng trang thông tin điện tử này.</p>
          <h2>THÔNG
            TIN KHÁCH HÀNG</h2>
          <p>Mọi
            thông tin của khách hàng đều là những nội dung quan trọng với TFSVN, vì vậy
            việc bảo vệ lĩnh vực riêng tư của bạn trong quá trình xử l&lrm;ý thông tin cá nhân
            là điều quan trọng mà chúng tôi đặc biệt lưu tâm trong suốt quá trình làm việc.<br>
            Trong vài vùng trên trang thông tin điện tử, TFSVN có thể yêu cầu bạn cho biết
            một số thông tin nhận biết cá nhân trước khi cung cấp cho bạn một dịch vụ nào
            đó. Các thông tin này, ví dụ như tên, địa chỉ thư tín, địa chỉ email, và các
            dạng yêu cầu, sẽ được thu nhận và lưu trữ phù hợp với bản chất của yêu cầu đó
            để đáp ứng nhu cầu của bạn. Nói cách khác, tất cả các thông tin bạn đưa ra sẽ
            được sử dụng để nâng cao chất lượng dịch vụ mà TFSVN cung cấp cho bạn.<br>
            Bạn có thể tin tưởng rằng, mọi thông tin bạn chia sẻ đều được TFSVN giữ gìn và
            cố gắng bảo mật, đồng thời luôn áp dụng những quy trình và chính sách bảo mật
            tốt nhất nhằm bảo vệ dữ liệu thông tin cá nhân của bạn khỏi mọi hành vi truy
            cập trái phép, phá hoại, sử dụng, chỉnh sửa và tiết lộ, ngoại trừ những điều
            được đưa ra dưới đây:<br>
            +
            Chúng tôi có thể tiết lộ những thông tin trên cho bên thứ ba nếu bạn đồng ý
            tiết lộ.</p>
          <p>+ Chúng tôi có thể tiết lộ
            những thông tin trên cho chi nhánh và đại lý của mình và những đối tác tiếp
            nhận khảo sát sản phẩm. Những đối tượng này sẽ truy cập thông tin cá nhân của
            bạn ở mức độ cần thiết để thực hiện chức năng, và không được phép chia sẻ thông
            tin với bất cứ bên thứ ba nào khác.</p>
          <p>+ Chúng tôi có thể tiết lộ
            những thông tin trên nếu được cơ quan nhà nước có thẩm quyền yêu cầu hoặc nếu
            chúng tôi tin rằng làm như vậy là cần thiết để: (a) phù hợp với những đòi hỏi
            hợp pháp hoặc tuân theo quy trình hợp pháp; (b) bảo vệ quyền hoặc tài sản của TFSVN
            hoặc những công ty liên kết; (c) ngăn chặn tội ác hoặc bảo vệ quốc gia; hoặc
            (d) bảo vệ an toàn cá nhân của người sử dụng hoặc công chúng. </p>
          <h2>THÔNG
            TIN BẢN QUYỀN/ĐĂNG KÝ NHÃN HIỆU</h2>
          <p>Tất
            cả các thông tin hiển thị trên trang thông tin điện tử này bao gồm, nhưng không
            giới hạn: tên các dòng xe; khẩu hiệu; các logo, văn bản, đồ họa, hình ảnh và
            biểu tượng và các tài liệu khác đều là đối tượng của quyền tác giả, quyền sở
            hữu trí tuệ khác của TFSVN. <br>
            Đồng thời, đối với trang thông tin điện tử này và tất cả các nội dung trong
            trang thông tin điện tử này, không được phép sao chép, tái tạo lại, phát hành
            lại, tải lên, đăng tải, truyền đi, phân phối hoặc sử dụng để tạo ra các công
            việc phái sinh mà không có sự đồng ý trước bằng văn bản của TFSVN. Riêng đối
            với logo, biểu tượng TFSVN, nghiêm cấm sử dụng, tải về, sao chép hoặc phân phối
            dưới bất kỳ hình thức nào.<br>
            Trong một số trường hợp, TFSVN cho phép bạn một cách hạn chế, không độc quyền, không
            chuyển giao để truy cập và hiển thị các trang bên trong trang thông tin điện tử
            này, chỉ riêng trên máy tính của bạn và chỉ phục vụ mục đích sử dụng cá nhân,
            phi thương mại. Sự cho phép này tồn tại với điều kiện:<br>
            +
            Bạn không được phép thay đổi nội dung được hiển thị trên trang thông tin điện
            tử này, phải giữ nguyên vẹn giữ lại tất cả quyền tác giả và các thông báo về
            quyền sở hữu khác của các tài liệu này, và phải chấp nhận bất kỳ điều khoản,
            điều kiện và thông báo nào đi kèm với các nội dung hoặc bất kỳ điều gì khác
            được quy định trong trang thông tin điện tử này.</p>
          <p>+ Bạn không được sửa đổi tài
            liệu dưới bất kì hình thức nào hoặc sao chép hoặc công bố công khai, trình bày,
            phân phối hoặc sử dụng các tài liệu đó với mục đích thương mại hoặc truyền bá.</p>
          <p>+ Bạn không được sao chép bất
            kỳ nội dung nào từ trang thông tin điện tử này sang bất kỳ trang thông tin điện
            tử hoặc phương tiện thông tin nào khác.</p>
          <p>Việc
            bạn không thể tuân thủ những điều khoản, điều kiện và thông báo trên trang
            thông tin điện tử này sẽ dẫn đến việc tự động tước đi bất kỳ quyền nào của bạn,
            mà không cần phải báo trước, và bạn phải ngay lập tức hủy bỏ tất cả các bảo sao
            của các tài liệu đã được tải về mà bạn đang có hoặc đang kiểm soát. Ngoại trừ
            đối với những sự cho phép hạn chế đã đề cập đến ở đoạn trên, TFSVN không trao
            bất cứ một quyền ngụ ý hay công khai, hoặc giấy phép đối với bất kỳ bằng phát
            minh, bằng sang chế, thương hiệu, bản quyền nào hoặc quyền sở hữu hay quyền sở
            hữu trí tuệ nào khác.</p>
          <h2>THAY
            ĐỔI NỘI DUNG SẢN PHẨM, GIÁ CẢ</h2>
          <p>Tất
            cả những hình ảnh minh họa, thông tin, thông số kỹ thuật và giá cả được đề cập
            trên trang thông tin điện tử này là chính xác vào thời điểm xây dựng trang
            thông tin điện tử . Tuy nhiên, TFSVN có quyền thay đổi hoặc hủy bỏ mẫu mã, đặc
            tính, thông số, thiết kế và giá cả của sản phẩm được đề cập trên trang thông
            tin điện tử này vào bất cứ thời điểm nào mà không cần phải thông báo trước.<br>
            Vui lòng hãy liên hệ với TFSVN hoặc các đại lý tại các địa phương để có thông
            tin hoặc chi tiết mới nhất, phù hợp và chính xác nhất.</p>
          <h2>MỘT
            SỐ MIỄN TRỪ TRÁCH NHIỆM NHẤT ĐỊNH</h2>
          <p><strong>1/
            Trách nhiệm thông tin</strong><br>
            Thông tin trên trang thông tin điện tử này do TFSVN cung cấp và hoàn toàn hợp
            pháp. TFSVN luôn cố gắng cập nhật và cung cấp tới bạn các thông tin chính xác
            nhất. Tuy nhiên, trong quá trình cung cấp thông tin, trang thông tin điện tử
            này có thể chứa những sai sót kỹ thuật hoặc lỗi đánh máy, do đó, thông tin trên
            trang thông tin điện tử này không được hứa hẹn hoặc đảm bảo là chính xác, cập
            nhật hoặc hoàn chỉnh.Trong mọi trường hợp, TFSVN không chịu trách nhiệm đối với
            bên nào về bất kỳ thiệt hại gián tiếp, trực tiếp, ám chỉ, đặc biệt, mang tính
            cảnh cáo hoặc mang tính hậu quả ở bất kỳ thể loại nào và vì bất kỳ lý do nào
            liên quan đến hoặc phát sinh từ trang thông tin điện tử này hoặc việc sử dụng
            trang thông tin điện tử này, hoặc của bất kỳ trang thông tin điện tử nào hoặc
            tài nguyên nào được liên kết với, được tham chiếu đến hoặc được truy cập thông
            qua trang thông tin điệnt ử này, hoặc đối với việc sử dụng hay tải xuống, hay
            truy cập vào bất kỳ tài liệu, thông tin, sản phẩm hoặc dịch vụ nào kể cả khi TFSVN
            khuyến nghị rõ ràng về khả năng xảy ra những thiệt hại như vậy. <br>
            <strong>2/ Các liên kết khác</strong><br>
            Trang thông tin điện tử này có thể có những đường liên kết với các trang thông
            tin điện tử khác. TFSVN cung cấp những kết nối này nhằm thuận tiện hơn cho bạn
            và điều đó không có nghĩa là TFSVN chịu trách nhiệm cho các trang kết nối này
            hay trang thông tin điện tử nay dưới quyền kiểm soát của TFSVN. <br>
            Xin vui lòng biết rằng TFSVN không chịu trách nhiệm thực hiện hay các quy định
            về quyền riêng tư hay nội dung hoặc các quy định về bảo mật đối với những trang
            thông tin điện tử đó. Quyền sử dụng của bạn đối với các liên kết và ứng dụng
            tùy thuộc vào chính sách riêng của các trang kết nối hay trang thông tin điện
            tử đó. Do vậy, Chúng tôi khuyến khích người sử dụng tìm hiểu chính sách về
            quyền riêng tư, hướng dẫn bảo mật cũng như các nội dung của các trang kết nối
            hay trang thông tin điện tử này trước khi sử dụng liên kết hoặc ứng dụng đó.</p>
          <p><strong>QUYỀN THAY ĐỔI</strong></p>
          <p>TFSVN
            giữ quyền thay đổi những Điều khoản sử dụng trên đây và bất kỳ thông tin nào
            trong trang thông tin điện tử này vào bất kỳ lúc nào mà không cần phải thông
            báo trước cho bạn. TFSVN cũng có thể đưa ra những cải tiến hoặc thay đổi trong
            các sản phẩm, dịch vụ hoặc chương trình được mô tả trong trang thông tin điện
            tử này vào bất kỳ lúc nào mà không báo trước. Chúng tôi sẽ đăng tải những thay
            đổi đó lên trang thông tin điện tử để người sử dụng luôn nhận thức những thông
            tin chúng tôi thu thập, cách thức chúng tôi sử dụng những thông tin đó và những
            trường hợp mà chúng tôi tiết lộ những thông tin đó. </p>
          <p>Cập nhật lần cuối ngày 01/01/2020</p>
      </div>
      </perfect-scrollbar>
      <!--Footer-->
      <div class="modal-footer">
        <button class="modal-close px-4 p-3" @click="isShownTermsModal=false">
          OK
        </button>
      </div>
      </div>
    </div>
    </UiModal>
    <UiModal closeOnOverlay :show.sync="isShownPrivacyModal">
    <div class="modal-container modal-scroll bg-white w-11/12 md:max-w-md mx-auto shadow-lg z-50 overflow-y-auto">
      <div class="modal-content text-left">
      <!--Title-->
      <div class="modal-header bg-danger text-white">
        <div class="modal-title">
          Chính sách bảo mật
          <div class="modal-close" @click="isShownPrivacyModal=false">
            <img
              src="@/assets/img/icon-close-white.svg"
              alt="Close"
            />
          </div>
        </div>
      </div>
      <!--Body-->
      <perfect-scrollbar>
      <div class="modal-body">
          <p>1. TỔNG QUAN VỀ CHÍNH SÁCH BẢO MẬT THÔNG TIN</p>
          <p>1.1 Công ty TNHH MTV Tài chính TOYOTA VIỆT NAM (“TFSVN”) hiểu rõ tầm
            quan trọng và tôn trọng quyền bảo mật thông tin cá nhân (“Thông tin”) của người
            truy cập website và sử dụng dịch vụ của TFSVN (người truy cập website và/hoặc
            mua sản phẩm, sử dụng dịch vụ của TFSVN sau đây gọi chung là “Khách hàng”);
            website, sản phẩm và dịch vụ sau đây gọi chung là “Dịch vụ”), bằng thiện chí của
            mình – TFSVN với Chính sách bảo mật Thông tin này (“Chính sách”) sẽ cung cấp nội
            dung tổng quan nhằm minh bạch hóa mục đích thu thập thông tin; phạm vi và
            phương thức thu thập thông tin; phạm vi sử sụng, đối tượng tiếp cận, thời gian
            lưu trữ thông tin; các liên kết và sản phẩm của bên thứ ba trên website; cam kết
            bảo mật thông tin; quyền lợi và trách nhiệm của Khách hàng; thông tin và phương
            thức liên hệ được nêu tại Chính sách này.</p>
          <p>1.2 Chính sách này áp dụng đối với tổng thể Dịch vụ của TFSVN, nhưng
            tùy từng thời điểm, đối với từng Dịch vụ hoặc từng phần Dịch vụ cụ thể, tùy thuộc
            đặc thù và yêu cầu cần thiết của Dịch vụ đó TFSVN có thể bổ sung/điều chỉnh các
            nội dung liên quan đến Chính sách này để áp dụng riêng cho những phần Dịch vụ cụ
            thể đó.</p>
          <p>1.3 Chính sách này được áp dụng khi Khách hàng truy cập website, sử dụng
            Dịch vụ trên website của TFSVN, và bất kỳ thời điểm nào Khách hàng truy cập, sử
            dụng Dịch vụ trên website do TFSVN cung cấp, tức là Khách hàng đồng ý và chịu sự
            ràng buộc với các điều khoản mà TFSVN quy định trong Chính sách này (bao gồm cả
            các phần bổ sung, sửa đổi tùy từng thời điểm).</p>
          <p>1.4 Tùy tình hình, nhu cầu bảo mật thực tế, TFSVN có thể điều chỉnh
            Chính sách này và sẽ thông báo trên website của TFSVN. </p>
          <p>Khi cập nhật nội dung chính sách này, TFSVN sẽ chỉnh sửa lại thời gian
            “Cập nhật lần cuối” ở phần cuối của Chính sách này, vì vậy trước khi truy cập,
            sử dụng Dịch vụ của TFSVN Khách hàng nên thường xuyên kiểm tra lại Thông tin
            Chính sách để có các bản cập nhật mới nhất.</p>
          <p>2. MỤC ĐÍCH THU THẬP THÔNG TIN</p>
          <p>TFSVN thu thập Thông tin của Khách hàng chủ yếu phục vụ cho mục đích hỗ
            trợ, duy trì mối liên hệ với Khách hàng như:</p>
          <p>2.1 Duy trì liên lạc với Khách hàng, giải đáp các thắc mắc của Khách
            hàng liên quan đến Dịch vụ của TFSVN;</p>
          <p>2.2 Nâng cao chất lượng Dịch vụ của TFSVN và/hoặc các Dịch vụ của các
            Công ty liên kết của TFSVN (“Đơn vị trực thuộc”).</p>
          <p>2.3 Thiết lập các chương trình hỗ trợ khách hàng thân thiết hoặc các
            chương trình xúc tiến thương mại khác;</p>
          <p>2.4 Xử lý các vấn đề liên quan đến việc sử dụng Dịch vụ của Khách hàng
            hoặc giao dịch giữa TFSVN và Khách hàng;</p>
          <p>2.5 Gửi thư ngỏ, đơn đặt hàng, thư cảm ơn;</p>
          <p>2.6 Thông báo đến Khách hàng các Thông tin khuyến mại, quảng cáo hoặc
            cho các mục đích tiếp thị trực tiếp, xúc tiến thương mại khác khi có sự đồng ý
            trước của Khách hàng.</p>
          <p>2.7 Thông báo về các thông tin tuyển dụng của TFSVN nếu Khách hàng đăng
            kí nhận email thông báo.</p>
          <p>2.8 Đánh giá và phân tích thị trường, khách hàng, Dịch vụ của TFSVN</p>
          <p>2.9 Hỗ trợ khi Khách hàng mua xe và/hoặc sử dụng Dịch vụ của TFSVN.</p>
          <p>2.10 TFSVN thu thập Thông tin để phục vụ cho các mục đích kiểm soát,
            nâng cao chất lượng Dịch vụ như:</p>
          <p>a) Kiểm soát người truy cập, sử dụng Dịch vụ của TFSVN;</p>
          <p>b) Phân tích và tối ưu hóa các Dịch vụ của TFSVN;</p>
          <p>2.11 Các nội dung khác mà TFSVN được phép sử dụng Thông tin không trái
            với quy định của pháp luật.</p>
          <p>3. PHẠM VI THU THẬP THÔNG TIN</p>
          <p>3.1 Thông tin của Khách hàng mà TFSVN sẽ thu thập bao gồm:</p>
          <p>a) Họ tên;</p>
          <p>b) Số điện thoại;</p>
          <p>c) Email;</p>
          <p>d) Địa chỉ thường trú;</p>
          <p>3.2 Cho từng Dịch vụ, mục đích thu thập cụ thể khác, tùy từng thời điểm
            TFSVN có thể yêu cầu Khách hàng cung cấp thêm một số Thông tin nhằm đảm bảo việc
            sử dụng Dịch vụ của chính Khách hàng hoặc đảm bảo sự liên hệ, giao dịch giữa TFSVN
            và Khách hàng được thông suốt, thuận tiện ví dụ như: loại xe Khách hàng sở hữu,
            yêu thích; biển số xe; số km đã đi) và/hoặc các Thông tin cần thiết khác.</p>
          <p>3.3 Đối với phạm vi thu thập Thông tin đề cập tại Chính sách này, TFSVN
            sẽ luôn tạo điều kiện bằng cách thiết lập những tính năng trên giao diện
            Website để Khách hàng tùy chọn để quyết định việc cung cấp hoặc từ chối cung cấp
            Thông tin cho TFSVN.</p>
          <p>4. PHƯƠNG THỨC THU THẬP THÔNG TIN</p>
          <p>Nhằm đảm bảo Thông tin được thu thập là đầy đủ, chính xác, tùy trường hợp
            TFSVN có thể lựa chọn sử dụng đơn lẻ hoặc tổng hợp các phương thức thu thập
            Thông tin của Khách hàng như sau:</p>
          <p>4.1 Đề nghị Khách hàng cung cấp Thông tin</p>
          <p>TFSVN có thể đề nghị Khách hàng cung cấp Thông tin trong các trường hợp
            sau:</p>
          <p>a) Một số Dịch vụ của TFSVN cho phép/đề nghị Khách hàng tạo tài khoản
            hoặc hồ sơ cá nhân và để sử dụng một cách tốt nhất các Dịch vụ này, TFSVN có thể
            yêu cầu Khách hàng cung cấp các Thông tin đề cập tại Mục 3 nêu trên để đáp ứng
            nhu cầu sử dụng Dịch vụ của Khách hàng.</p>
          <p>b) Trường hợp Khách hàng yêu cầu TFSVN giải đáp các thắc mắc liên quan
            đến Dịch vụ của TFSVN hoặc Khách hàng yêu cầu TFSVN cung cấp Dịch vụ ví dụ: yêu
            cầu hỗ trợ bảo trì xe Ô tô thì TFSVN có thể yêu cầu Khách hàng cung cấp Thông
            tin để xử lý các yêu cầu của Khách hàng một cách nhanh chóng, chính xác;</p>
          <p>c) Các trường hợp yêu cầu thu thập Thông tin khác tùy theo nhu cầu thu
            thập của TFSVN.</p>
          <p>d) TFSVN sẽ luôn đưa ra tùy chọn về việc quyết định cung cấp hay không
            cung cấp Thông tin đối với Khách hàng. Trường hợp Khách hàng lựa chọn không
            cung cấp Thông tin có thể sẽ có một số Dịch vụ, giao dịch không thể thực hiện
            được hoặc một số giao dịch Khách hàng sẽ được truy cập, thực hiện dưới chế độ ẩn
            danh (Guest).</p>
          <p>4.2 TFSVN tự thu thập Thông tin</p>
          <p>a) Thu thập Thông tin từ các nguồn của bên thứ ba</p>
          <p>TFSVN có thể nhận Thông tin về Khách hàng đã công bố công khai trên các
            website thương mại điện tử của bất kỳ bên thứ ba nào hoặc nhận Thông tin của
            Khách hàng từ bên thứ ba khi TFSVN tham gia vào các giao dịch có sự chuyển giao
            Thông tin đó.</p>
          <p>b) Thu thập trong quá trình thực hiện Dịch vụ</p>
          <p>Trong quá trình thực hiện Dịch vụ, TFSVN cũng có thể thu thập các Thông
            tin của Khách hàng bằng các cách thức phù hợp khác với sự đồng ý của Khách hàng
            với cách thức thu thập đó.</p>
          <p>c) Thu thập trong quá trình Khách hàng sử dụng Dịch vụ</p>
          <p>4.3 Hợp nhất Thông tin</p>
          <p>TFSVN có thể hợp nhất Thông tin Khách hàng mà TFSVN có được từ việc thu
            thập bằng nhiều phương thức khác nhau đề cập tại Mục này như một thao tác hoàn
            thiện Thông tin để phục vụ cho các mục đích được đề cập tại Chính sách này mà
            không cần sự đồng ý trước của Khách hàng. Tuy nhiên Khách hàng luôn có quyền lựa
            chọn điều chỉnh Thông tin của mình theo quy định tại Mục 10.1 Chính sách này.</p>
          <p>5. PHẠM VI SỬ DỤNG THÔNG TIN</p>
          <p>Các thông tin của Khách hàng thu thập được để sử dụng cho mục đích được
            nêu tại mục 2 của Chính sách này. Bên cạnh đó, các thông tin được sử dụng trong
            phạm vi TFSVN và/hoặc đối tác của TFSVN (các đại lý).</p>
          <p>6. ĐỐI TƯỢNG TIẾP CẬN THÔNG TIN</p>
          <p>6.1 Để thực hiện mục đích thu thập Thông tin đề cập tại Chính sách này TFSVN
            có thể cần sự hỗ trợ từ bên thứ ba để phân tích dữ liệu, tiếp thị và hỗ trợ dịch
            vụ khách hàng và/hoặc cung cấp Dịch vụ tốt hơn cho Khách hàng. Trong quá trình
            hỗ trợ, Thông tin của Khách hàng có thể được TFSVN tiết lộ cho các đối tượng được
            đề cập dưới đây:</p>
          <p>a) Đơn vị trực thuộc của TFSVN khi sự tham gia của Đơn vị trực thuộc là
            cần thiết để thực hiện/hoàn thiện giao dịch đã thiết lập giữa TFSVN với Khách
            hàng.</p>
          <p>b) Đối tác kinh doanh mà TFSVN tin tưởng, việc tiết lộ và trách nhiệm bảo
            mật Thông tin của Khách hàng sẽ được thực hiện theo thỏa thuận giữa TFSVN và đối
            tác kinh doanh của TFSVN.</p>
          <p>6.2 Để phát triển hoạt động kinh doanh hoặc trong trường hợp bất khả
            kháng TFSVN có thể phải thực hiện tổ chức lại, chuyển nhượng, giải thể hoặc phá
            sản công ty, trường hợp này các đơn vị kế thừa, nhận chuyển nhượng của TFSVN có
            thể sẽ tiếp nhận Thông tin của Khách hàng để thay thế TFSVN tiếp tục cung cấp,
            thực hiện Dịch vụ với Khách hàng.</p>
          <p>6.3 TFSVN sẽ phải tiết lộ Thông tin của Khách hàng cho Bên thứ ba hoặc
            cho cơ quan có thẩm quyền khi được cơ quan có thẩm quyền yêu cầu hoặc các trường
            hợp khác theo quy định của pháp luật hoặc TFSVN có cơ sở để tin rằng việc tiết
            lộ Thông tin có thể bảo vệ quyền, tài sản hoặc an toàn của chính Khách hàng hoặc
            của TFSVN/Đơn vị trực thuộc của TFSVN.</p>
          <p>6.4 Các bên khác khi có sự đồng ý hoặc theo hướng dẫn của Khách hàng.</p>
          <p>7. THỜI GIAN LƯU TRỮ THÔNG TIN</p>
          <p>TFSVN chỉ lưu giữ Thông tin về Khách hàng trong thời gian cần thiết cho
            mục đích mà Thông tin được thu thập.</p>
          <p>8. CÁC LIÊN KẾT VÀ SẢN PHẨM CỦA BÊN THỨ BA TRÊN WEBSITE</p>
          <p>8.1 Một số nội dung, quảng cáo và tính năng trên trang web của TFSVN có
            thể được cung cấp bởi các bên thứ ba có hoặc không liên kết với TFSVN. Các bên
            thứ ba này có thể thu thập hoặc nhận Thông tin nhất định về việc Khách hàng sử
            dụng Dịch vụ, kể cả thông qua việc sử dụng Cookie, Beacon và các công nghệ
            tương tự và Thông tin này có thể được thu thập theo thời gian, đồng thời được kết
            hợp với Thông tin được thu thập trên các Website và dịch vụ trực tuyến khác
            nhau.</p>
          <p>8.2 Nếu Khách hàng kết nối với dịch vụ mạng xã hội, TFSVN có thể nhận
            và lưu trữ Thông tin xác thực từ dịch vụ đó để cho phép Khách hàng đăng nhập,
            cũng như Thông tin khác mà Khách hàng cho phép TFSVN nhận khi Khách hàng kết nối
            với các dịch vụ đó.</p>
          <p>8.3 Bằng cách truy cập và/hoặc sử dụng Dịch vụ của TFSVN, Khách hàng đồng
            ý lưu trữ Cookie, Beacon, các công nghệ lưu trữ cục bộ khác. Khách hàng cũng đồng
            ý quyền truy cập Cookie, Beacon, công nghệ lưu trữ cục bộ của TFSVN và các bên
            thứ ba được đề cập ở trên.</p>
          <p>8.4 Như đã nêu trên, Dịch vụ của TFSVN có thể có các liên kết đến các
            website của Bên thứ ba khác không thuộc quyền kiểm soát của TFSVN, do đó TFSVN
            sẽ không chịu trách nhiệm về sự an toàn hoặc bảo mật của bất kỳ Thông tin nào
            được thu thập bởi các Bên thứ ba đó, không được thực hiện trên giao diện
            website hoặc TFSVN có quyền quản lý và/hoặc kiểm soát. TFSVN khuyên Khách hàng
            nên thận trọng và xem xét các quyết định về bảo mật Thông tin áp dụng cho các
            Website và dịch vụ của Bên thứ ba mà Khách hàng sử dụng.</p>
          <p>9. CAM KẾT BẢO MẬT THÔNG TIN</p>
          <p>9.1 TFSVN cam kết bảo mật Thông tin của Khách hàng theo đúng các nội
            dung được quy định tại Chính sách này và quy định của pháp luật.</p>
          <p>9.2 TFSVN sẽ áp dụng phương án và giải pháp thích hợp về kỹ thuật và an
            ninh để bảo vệ hiệu quả nhất Thông tin của Khách hàng. Tuy nhiên, lưu ý rằng mặc
            dù TFSVN thực hiện các phương thức hợp lý để bảo vệ Thông tin của Khách hàng,
            nhưng không có trang web, đường truyền Internet, hệ thống máy vi tính hay kết nối
            không dây nào là an toàn tuyệt đối. Do vậy, TFSVN không thể đưa ra một cam kết
            chắc chắn rằng thông tin Khách hàng cung cấp cho TFSVN sẽ được bảo mật một cách
            tuyệt đối an toàn, và TFSVN không thể chịu trách nhiệm trong trường hợp có sự
            truy cập trái phép, rò rỉ Thông tin của Khách hàng mà không do lỗi của TFSVN. Nếu
            Khách hàng không đồng ý với các điều khoản như đã mô tả ở trên, TFSVN khuyến
            nghị Khách hàng không nên gửi Thông tin đến cho TFSVN.</p>
          <p>10. QUYỀN LỢI VÀ TRÁCH NHIỆM CỦA KHÁCH HÀNG</p>
          <p>10.1 Quyền lợi</p>
          <p>a) Khách hàng được bảo đảm các quyền lợi và bảo mật về Thông tin mà TFSVN
            đã cam kết theo Chính sách này;</p>
          <p>b) Khách hàng có quyền truy cập vào dữ liệu Thông tin của mình và có
            quyền tự điều chỉnh lại những sai sót trong dữ liệu cá nhân của mình hoặc cập
            nhật, bổ sung để hoàn thiện Thông tin được lưu trữ trên website. Khách hàng
            cũng có quyền tự xóa dữ liệu cá nhân trên website hoặc yêu cầu TFSVN ngưng sử dụng
            dữ liệu cá nhân cho mục đích tiếp thị bằng cách gửi yêu cầu ngưng các hoạt động
            nhận thông báo, thông tin từ website.</p>
          <p>c) Nếu Khách hàng không muốn nhận bất cứ thông tin quảng cáo, chương
            trình khuyến mại của TFSVN thì có quyền từ chối bất cứ lúc nào bằng cách gửi
            yêu cầu ngưng nhận thông tin đến website của TFSVN theo các tính năng đã được
            hướng dẫn ở cuối trang.</p>
          <p>10.2 Trách nhiệm của Khách hàng</p>
          <p>a) Tìm hiểu kỹ Chính sách này trước khi sử dụng, truy cập Dịch vụ của TFSVN.,
            Việc Khách hàng sử dụng, truy cập Dịch vụ của TFSVN cũng chính là sự xác nhận
            việc đã tìm hiểu kỹ và đồng ý với toàn bộ nội dung Chính sách này.</p>
          <p>b) Cung cấp Thông tin chính xác, hợp pháp cho TFSVN khi được đề nghị và
            đồng ý cung cấp. Khách hàng sẽ hoàn toàn chịu trách nhiệm (trong mọi trường hợp,
            không có sự liên đới nào đến TFSVN dù cho một phần hay toàn bộ) nếu Thông tin
            Khách hàng cung cấp cho TFSVN là không chính xác, không hợp pháp và/hoặc việc
            thực hiện Dịch vụ của Khách hàng bị gián đoạn, không thể thực hiện; hoặc giao dịch
            giữa TFSVN và Khách hàng, giữa TFSVN và Bên thứ ba, giữa Khách hàng và Bên thứ
            ba bị gián đoạn hoặc không thể thực hiện được vì yếu tố kỹ thuật, đường truyền,
            lỗi hệ thống, v.v. hoặc phát sinh bất kể thiệt hại vật chất, phi vật chất nào từ
            việc sử dụng những Thông tin không chính xác/vi phạm pháp luật này.</p>
          <p>c) Không sử dụng bất kỳ chương trình, công cụ hay hình thức nào khác để
            can thiệp vào hệ thống hay làm thay đổi cấu trúc dữ liệu của Dịch vụ, giao diện
            của website, các tính năng hiện hữu của website TFSVN.</p>
          <p>d) Không phát tán, truyền bá hay cổ vũ cho bất kỳ hoạt động nào nhằm
            can thiệp, phá hoại hay xâm nhập vào dữ liệu của hệ thống website thuộc quyền
            quản lý của TFSVN.</p>
          <p>e) Không truyền bá, phát tán nội dung vi phạm pháp luật và/hoặc trái đạo
            đức xã hội tại website của TFSVN.</p>
          <p>f) Mọi vi phạm sẽ bị xử lý theo quy định của pháp luật.</p>
          <p>11. THÔNG TIN, PHƯƠNG THỨC LIÊN HỆ</p>
          <p>TFSVN trân trọng mọi ý kiến đóng góp, liên hệ và phản hồi thông tin từ
            Khách hàng về Dịch vụ của TFSVN cũng như chính sách này. Mọi thắc mắc liên
            quan, Khách hàng vui lòng liên hệ theo thông tin dưới đây:</p>
          <p>Công ty TNHH MTV Tài chính Toyota Việt Nam</p>
          <p>                                                         Tầng 12, Tòa nhà Saigon Centre Tòa 2, số 67 Đường Lê Lợi, Phường Bến Nghé, Quận 1, TP.HCM <br>Tel:  (84-28) 7309 0998 <br>Fax: (84-28) 3911 0113 <br>Email: cs@toyotafinancial.com.vn      </p>
          <p>Cập nhật lần cuối ngày 01/01/2020</p>
      </div>
      </perfect-scrollbar>
      <!--Footer-->
      <div class="modal-footer">
        <button class="modal-close px-4 p-3" @click="isShownPrivacyModal=false">
          OK
        </button>
      </div>
      </div>
    </div>
    </UiModal>
  </div>
</template>

<script>
import { AuthService } from '@/services/auth.service'
import UiToastList from '@/components/UiToastList'
import VueRecaptcha from 'vue-recaptcha'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import UiModal from '@/components/UiModal'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

export default {
  name: 'Login',
  mixins: [validationMixin],
  data () {
    return {
      recaptcha_site_key: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      username: '',
      password: '',
      error: '',
      passwordInputType: 'password',
      isRequest: false,
      recaptchaVerified: false,
      pleaseTickRecaptchaMessage: '',
      submitted: false,
      isShownPrivacyModal: false,
      isShownTermsModal: false,
      remember: false
    }
  },
  validations: {
    username: { required },
    password: { required }
  },
  methods: {
    onCaptchaVerified: function (response) {
      this.pleaseTickRecaptchaMessage = ''
      this.recaptchaVerified = true
      // const self = this
      // self.$refs.recaptcha.reset()
    },
    makeLogin () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      if (!this.recaptchaVerified) {
        this.pleaseTickRecaptchaMessage = 'Vui lòng xác nhận captcha'
        return
      }

      if (this.remember) {
        localStorage.setItem('remember_password', '1')
      }

      this.isRequest = true
      AuthService.makeLogin({
        username: this.username,
        password: this.password
      }).then(response => {
        const result = response.data
        if (result.data.IsLogin === false) {
          this.error = result.Message
        } else {
          this.error = ''
          if (result.data.IsFirstLogin === true) {
            return this.$router.push({ name: 'verifyOTP', params: { username: this.username, password: this.password, isloginpage: '1' } })
          } else {
            if (result.data.IsConfirmOTP === true) {
              return this.$router.push({ name: 'verifyOTP', params: { username: this.username, password: this.password } })
            }
          }
          this.$router.push({ name: 'loanSummary' })
        }
        this.isRequest = false
      }).catch((error) => {
        this.isRequest = false
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
      })
    },
    showPassword () {
      if (this.passwordInputType === 'password') {
        this.passwordInputType = 'text'
      } else {
        this.passwordInputType = 'password'
      }
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset()
    }
  },
  components: {
    VueRecaptcha,
    UiToastList,
    UiModal,
    PerfectScrollbar
  }
}
</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>
<style lang="scss" scoped>
  .g-recaptcha {
    transform: scale(1.1);
    transform-origin: 0 0;
  }

  @media only screen and (max-width: 767px) {
    .g-recaptcha {
      transform: scale(1.14);
      transform-origin: 0 0;
    }
  }
</style>
